import api from "./api";

export async function getKPIs() {
  const response = await api.get("/relatorios/kpis");
  return response.data.data;
}

export async function getResumoFinanceiro(dataInicio?: string, dataFim?: string) {
  const params = new URLSearchParams();
  if (dataInicio) params.append("dataInicio", dataInicio);
  if (dataFim) params.append("dataFim", dataFim);
  const response = await api.get(`/relatorios/financeiro?${params.toString()}`);
  return response.data.data;
}

// ===== Produtividade / entregas =====
export interface EntregaPorCategoria {
  tipoTarefaId: string | null;
  label: string;
  cor: string | null;
  quantidade: number;
}

export interface EntregaPorPessoa {
  usuario: { id: string; nome: string; fotoUrl: string | null };
  quantidade: number;
}

export interface ProdutividadePessoa {
  usuario: { id: string; nome: string; fotoUrl: string | null };
  /** false = ex-membro (desativado) que ainda teve atividade no período. */
  ativo?: boolean;
  setor: string | null;
  entregas: number;
  tempoUtilMs: number;
  noPrazoPct: number | null;
  retrabalhoMs: number;
  retrabalhoPct: number;
  /** Métricas do setor Atendimento (placar próprio). */
  cobrancas: number;
  dataClienteOkPct: number | null;
  dataClienteTotal: number;
  captacoes: number;
  cardsEstourados: number;
  ehAtendimento: boolean;
  pontos: number;
}

export interface MinhaProdutividade {
  entregas: number;
  tempoUtilMs: number;
  porCategoria: Array<{ label: string; quantidade: number }>;
}

export async function getEntregasPorCategoria(inicio: string, fim: string) {
  const qs = new URLSearchParams({ inicio, fim });
  const r = await api.get(`/relatorios/entregas-por-categoria?${qs.toString()}`);
  return r.data.data as EntregaPorCategoria[];
}

export async function getEntregasPorPessoa(inicio: string, fim: string, usuarioId?: string) {
  const qs = new URLSearchParams({ inicio, fim });
  if (usuarioId) qs.append("usuarioId", usuarioId);
  const r = await api.get(`/relatorios/entregas-por-pessoa?${qs.toString()}`);
  return r.data.data as EntregaPorPessoa[];
}

export async function getProdutividadeEquipe(inicio: string, fim: string) {
  const qs = new URLSearchParams({ inicio, fim });
  const r = await api.get(`/relatorios/produtividade-equipe?${qs.toString()}`);
  return r.data.data as ProdutividadePessoa[];
}

/** Métricas do placar que dá pra "abrir" e ver de onde vieram. */
export type MetricaDetalhe = "cobrancas" | "data_cliente" | "captacoes" | "estourados";

export interface LinhaDetalhe {
  tarefaId: string;
  titulo: string;
  projetoNome: string | null;
  clienteNome: string | null;
  data?: string | null;
  /** data_cliente: cumpriu o combinado? */
  ok?: boolean;
  concluidaEm?: string | null;
  /** estourados */
  diasParado?: number;
  ultimaCobrancaEm?: string | null;
  status?: string;
}

export async function getProdutividadeDetalhe(params: {
  usuarioId: string; metrica: MetricaDetalhe; inicio: string; fim: string;
}) {
  const qs = new URLSearchParams({
    usuarioId: params.usuarioId, metrica: params.metrica, inicio: params.inicio, fim: params.fim,
  });
  const r = await api.get(`/relatorios/produtividade-detalhe?${qs.toString()}`);
  return r.data.data as LinhaDetalhe[];
}

// Self-service — backend força o usuário autenticado; sem param de id.
export async function getMinhaProdutividade(inicio: string, fim: string) {
  const qs = new URLSearchParams({ inicio, fim });
  const r = await api.get(`/me/minha-produtividade?${qs.toString()}`);
  return r.data.data as MinhaProdutividade;
}

// ===== Contratado × Entregue por cliente =====
export interface HorasNivel { junior: number; pleno: number; senior: number }
export interface ProjetoContratadoEntregue {
  projetoId: string;
  nome: string;
  status: string;
  modalidade?: string;
  itensContratados: Array<{ label: string; quantidade: number; formato: string | null; horasVendidas: number | null; horasPorNivel: HorasNivel | null; especificacoes: string | null }>;
  itensContratadosQtd: number;
  horasVendidas: number;
  horasVendidasPorNivel: HorasNivel;
  tarefasTotal: number;
  entregues: number;
  horasRealizadasMs: number;
  realizadasMsPorNivel: HorasNivel;
  realizadasMsSemNivel: number;
}
export interface ContratadoEntregue {
  cliente: { id: string; nome: string };
  projetos: ProjetoContratadoEntregue[];
  totais: { itensContratados: number; horasVendidas: number; horasVendidasPorNivel: HorasNivel; entregues: number; tarefasTotal: number; horasRealizadasMs: number; realizadasMsPorNivel: HorasNivel; realizadasMsSemNivel: number };
}
export async function getContratadoEntregue(clienteId: string) {
  const r = await api.get(`/relatorios/contratado-entregue?clienteId=${encodeURIComponent(clienteId)}`);
  return r.data.data as ContratadoEntregue;
}

// MELHORIA 21 — relatório de entregas por CATEGORIA de peça (pro cliente).
export interface CategoriaEntrega { categoria: string; contratado: number; entregue: number; adicionais: number; pendente: number }
export interface PecaEntregue { id: string; titulo: string; quantidade: number; data: string; tipoLabel: string; tipoIcone: string; categoria: string }
export interface ItemEmAndamento { id: string; titulo: string; status: string; quantidade: number; prazo: string; tipoLabel: string; tipoIcone: string; categoria: string }
// MELHORIA 22 — horas vendido × realizado por tipo (dentro de cada categoria).
export interface TipoHoras { tipoTarefaId: string; tipoLabel: string; tipoIcone: string; categoria: string; vendidoH: number; realizadoMs: number }
export interface CategoriaHoras { categoria: string; vendidoH: number; realizadoMs: number; tipos: TipoHoras[] }
export interface RelatorioEntregas {
  cliente: { id: string; nome: string };
  periodo: { inicio: string; fim: string };
  categorias: CategoriaEntrega[];
  pecasEntregues: PecaEntregue[];
  emAndamento: ItemEmAndamento[];
  horasCategorias: CategoriaHoras[];
}
export async function getRelatorioEntregas(clienteId: string, inicio: string, fim: string) {
  const r = await api.get(`/relatorios/entregas?clienteId=${encodeURIComponent(clienteId)}&inicio=${inicio}&fim=${fim}`);
  return r.data.data as RelatorioEntregas;
}

// CONTRATADO CONSOLIDADO — total fechado somando TODOS os clientes (pra prever o mês).
export interface CategoriaContratadaGeral {
  categoria: string; contratado: number; entregue: number;
  // emAndamento = peças com card já rodando AGORA (foto do momento, não do mês).
  // aFazer = o que falta começar (contratado − entregue − emAndamento).
  emAndamento: number; pendente: number; aFazer: number;
  // Parte do entregue vinda de contrato já encerrado/arquivado (histórico).
  entregueEncerrados: number;
  clientes: number; projetos: number;
}
export interface ContratadoMensalGeral {
  periodo: { inicio: string; fim: string };
  apenasMensais: boolean;
  categorias: CategoriaContratadaGeral[];
  // Itens de contrato que não viram previsão de peças (contrato por pontos).
  semPrevisao: Array<{ projeto: string; item: string; quantidade: number }>;
  /** O que caiu no balde "Outros": tipos sem categoria + cards sem tipo. */
  tiposEmOutros: string[];
  totais: {
    contratado: number; entregue: number; entregueEncerrados: number;
    emAndamento: number; aFazer: number;
    clientes: number; projetos: number;
    // Contratos deixados de fora (cliente inativo ou fim de contrato já passado)
    // e projetos contados que ainda não têm data de fim cadastrada.
    encerrados: number; semDataFim: number;
  };
}
export async function getContratadoMensalGeral(inicio: string, fim: string, apenasMensais: boolean) {
  const r = await api.get(`/relatorios/contratado-mensal?inicio=${inicio}&fim=${fim}&apenasMensais=${apenasMensais}`);
  return r.data.data as ContratadoMensalGeral;
}
